<template>
  <div
    id="vessel-container-details"
    ref="vesselContainerDetails"
    class="vs-con-loading__container vx-card p-6"
  >
    <div class="flex flex-col">
      <div class="container-detail-header">
        <vs-row vs-w="12" type="flex">
          <div class="list-item cell" :style="'width: 100%'">
            <!-- コンテナ集計情報 -->
            <container-status-count-detail-view
              :counts="counts"
              :lastUpdatedAt="lastUpdatedAt"
              :enerpriseVesselName="enerpriseVesselName"
            />
          </div>
        </vs-row>
      </div>
    </div>

    <vs-row vs-w="12" type="flex">
      <div id="cotainer-stauts-list" class="py-2">
        <vs-col
          v-for="container_info in enterprise_vessel_containers"
          :key="container_info.id"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          :style="{
            'min-width': '93px',
            width: '93px',
            'font-weight': 300,
          }"
        >
          <container-status
            :container_info="container_info"
            :enterprise_vessel_id="enterprise_vessel_id"
            :customers="customerOptions"
            @refresh="refreshDisplay"
            :size="'small'"
          ></container-status>
        </vs-col>
      </div>
    </vs-row>
    <vs-row vs-w="12" type="flex">
      <div id="cotainer-pictures" class="w-full">
        <container-pictures
          :containerPictures="pictures"
          :isPictureReady="isPictureReady"
          :localPictureLastUpdatedAt="localPictureLastUpdatedAt"
        />
      </div>
    </vs-row>
  </div>
</template>

<script>
import ContainerStatusCountDetailView from "./components/ContainerStatusCountDetailView.vue";
import ContainerPictures from "./container-pictures/ContainerPictures.vue";
import { createNamespacedHelpers } from "vuex";
import ContainerStatus from "./components/ContainerStatus.vue";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

const { mapActions:mapActionsOfVessel } = createNamespacedHelpers("enterpriseVessel");
const { mapState, mapActions, mapGetters } = createNamespacedHelpers("ecoShip");
import moment from "moment-timezone";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const ecoShipVesselContainerPictures = AiseaApiFactory.get("ecoShipVesselContainerPictures");
import { db } from "@/firebase/firebaseConfig.js";

export default {
  name: "VesselContainerDetails",
  components: {
    ContainerStatus,
    ContainerStatusCountDetailView,
    ContainerPictures,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {},
  data() {
    return {
      device: "PC",
      enterprise_vessel_id: "",
      enterprise_vessel: {},
      enterprise_vessel_containers: [],
      customerOptions: [],

      hanasysExperts: [],
      channels: [],
      containerChannels: [],

      isLoading: true,
      routerViewWidth: 1366,
      pictures: [],
      unsubscribe: null,
      isPictureReady: false,
      localPictureLastUpdatedAt: null,
    };
  },
  watch: {
    onChangeWindowSize() {
      this.onResize();
      const routerViewElement = document.getElementsByClassName("router-view");
      if ( routerViewElement ){
        this.routerViewWidth = routerViewElement[0].getBoundingClientRect().width;
      } else {
        this.routerViewWidth = document.documentElement.clientWidth - 260;
      }
    },
  },
  computed: {
    ...mapGetters([
      "getEnterpriseVesselsWithContainers",
    ]),
    ...mapState({
      hanasysExpert: state => state.hanasysExpert,
      hanasysExpertLastUpdatedAt: state => state.hanasysExpertLastUpdatedAt,
    }),
    cardWidthByDevice() {
      const orientation = this.getDeviceInfo().deviceOrientation;
      let widthMinMax = [];
      if ( this.device === 'iPhone' && orientation === 'portrait' ) {
        widthMinMax = ['calc( 100% / 1 )', 'calc( 100% / 1 )'];
      } else if ( this.device === 'iPhone' && orientation === 'landscape' ) {
        widthMinMax = ['calc( 100% / 2 )', 'calc( 100% / 2 )'];
      } else if ( this.device === 'iPad' && orientation === 'portrait' ) {
        widthMinMax = ['calc( 100% / 2 )', 'calc( 100% / 2 )'];
      } else if ( this.device === 'iPad' && orientation === 'landscape' ) {
        widthMinMax = ['calc( 100% / 4 )', 'calc( 100% / 4 )'];
      } else {
        if ( this.routerViewWidth  <= 1286 ) {
          widthMinMax = ['calc( 100% / 4 )', 'calc( 100% / 4 )'];
        } else {
          widthMinMax = ['calc( 100% / 5 )', 'calc( 100% / 5 )'];
        }
      }
      return  {
                'min-width': widthMinMax[0],
                'width': widthMinMax[1],
              };
    },
    counts() {
      const counts = {
        container_count: 0,
        active_count: 0,
        alert_count: 0,
        interlock_count: 0,
        power_off_count: 0,
      };

      // コンテナ数
      counts.container_count = this.enterprise_vessel_containers.length;
      // 各コンテナの状態カウント
      this.channels
        .filter((channel) => channel.category3_id === null)
        .map((channel) => channel.channel_id)
        .forEach((channel_id) => {
          const channel = this.hanasysExpert[channel_id]; // firestoreのデータ

          if (channel && channel.properties) {
            const properties = JSON.parse(channel.properties);
            if (properties.tag_status === "I") {
              if (channel.vs === "NO-VOLT") {
                counts.power_off_count++;
              } else {
                counts.interlock_count++;
              }
            } else if (properties.tag_status === "A") {
              counts.alert_count++;
            } else if (channel.vs === "RUN") {
              counts.active_count++;
            } else {
              counts.power_off_count++;
            }
          }
        });
      return counts;
    },
    lastUpdatedAt() {
      // 最終更新日時
      if (this.channels.length === 0) return null;
      if (this.hanasysExpert.length === 0) return null;
      const lastTimestamp = this.channels
        .filter((channel) => channel.category3_id === null)
        .map((channel) => this.hanasysExpert[channel.channel_id])
        .filter((cd) => cd && cd.timestamp)
        .reduce((prev, cd, index) => {
          if (index === 0) return cd.timestamp;
          prev < cd.timestamp ? cd.timestamp : prev;
        }, null);
      return lastTimestamp === null
        ? null
        : moment(this.hanasysExpertLastUpdatedAt * 1000)
            .local()
            .format("YYYY/MM/DD HH:mm");
    },
    enerpriseVesselName() {
      if(!this.enterprise_vessel) return "";
      const {name_ja, name} = this.enterprise_vessel;
      return name_ja || name || "";
    },
    enterpriseId() {
      return this.$store.state.auth.user.id;
    },
    vesselId() {
      if(!this.enterprise_vessel) return "";
      return this.enterprise_vessel.id;
    },
  },
  methods: {
    ...mapActionsOfVessel(["getVessel"]),
    ...mapActions([
      "fetchVessels",
      "fetchVesselContainers",
      "fetchContainerCustomers",
      "getChannelMaster",
      "getVersion",
      "getHanasysExpartData",
      "unsubscribeFirestore",
      "getVesselContainers",
    ]),
    // TODO: 次のフェーズで使用する可能性があるためコメントを残しておく
    // async getCustomers() {
    //   let payload = {};
    //   let res = await this.fetchContainerCustomers(payload);
    //   this.customerOptions = res.enterprise_container_customers;
    // },
    backToMaster() {
      this.$router.push({
        name: "addon-eco-ship-vessel-container-master",
      });
    },
    async refreshDisplay() {
      this.isLoading = true;
      // this.getCustomers();
      const enterpriseVessels = await this.fetchVessels() ;
      this.enterprise_vessel = enterpriseVessels.vessels.find(x => x.enterprise_vessel_id === this.enterprise_vessel_id);
      const vesselContainers = await this.getVesselContainers(this.enterprise_vessel);
      if ( vesselContainers ) {
        this.channels = vesselContainers.channels;
        this.enterprise_vessel_containers = vesselContainers.enterprise_vessel_containers;  // コンテナカードリストとして一覧表示. （軸）
      }
      this.isLoading = false;
    },
    /**
     *  iPhone,iPadでのレフトメニュー表示制御.
     */
    onResize() {
      this.$nextTick(() => {
        if ( ["iPhone", "iPad"].includes( this.getDeviceInfo().deviceType )) {
          // iPhone, iPad はメニューを表示しない。
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
          this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");
        } else {
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
          const verticalNavMenuWidth = this.$store.state.reduceButton
            ? "reduced"
            : "default";
          this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);
        }
      });
    },
  },
  created() {
    this.enterprise_vessel_id = this.$route.query.id;
    this.device = this.getDeviceInfo().deviceType;
    this.onResize();
  },
  async mounted() {
    this.$vs.loading();

    await this.refreshDisplay();
    this.$nextTick(() => {
      this.$vs.loading.close();
    });

    // 写真データ更新をlistenするためにsnapshot
    const docRef = db
      .collection("enterprise_vessel_dashboard")
      .doc("e:" + this.enterpriseId)
      .collection("v:" + this.vesselId)
      .doc("container");
    this.unsubscribe = await docRef
      .onSnapshot(async () => {
        try {
          this.$vs.loading();
          const res = await ecoShipVesselContainerPictures.fetch(this.vesselId);
          if (res.status !== true) throw new Error();
          this.pictures = res.data;
          this.localPictureLastUpdatedAt = moment().unix();
        } catch (e) {
          // notifiy
          this.$vs.notify({
            title: "コンテナ写真を取得できませんでした。",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
          });
        } finally {
          this.$nextTick(() => {
            this.$vs.loading.close();
            this.isPictureReady = true;
          });
        }
      });
  },
  beforeDestroy() {
    this.unsubscribeFirestore();
    this.unsubscribe();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
#vessel-container-details {
  .container-list-header {
    margin-top: 0.4rem;
  }
  .container-list-header-small {
    margin-top: 1rem;
  }
  .vessel-name-last-updated-at {
    margin-left: 0.4rem;
  }
  .container-detail-header {
    border-bottom: solid 1px $aisea-light-gray;
  }

  .last-updated-at {
    display: none;
    @media screen and (min-width: $max-width-iphone-8) {
      display: inherit;
      margin: 0.4rem 0;
      background: $aisea-white;
      border-radius: 20px;
      padding: 2px 7px;
    }
  }
  #cotainer-stauts-list {
    border-bottom: solid 1px $aisea-light-gray;
    .container-card-small {
      background-color: $aisea-white;
      padding-left: 4px;
    }
  }
  .container-count {
    display: flex;
    @media screen and (min-width: $max-width-iphone-11-pro) {
      display: none;
    }
  }

  @media (max-width: 576px) {
    .xs-view {
      display: inline !important;
    }
    .lg-view {
      display: none !important;
    }
  }
  @media (min-width: 575px) {
    .xs-view {
      display: none !important;
    }
    .lg-view {
      display: inline !important;
    }
  }

  .back-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 30px;
    cursor: pointer;
    word-break: keep-all;
  }
  .vessel-name {
    width: calc(100%);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0.8rem auto 1.2rem 0.4rem;
  }
}
</style>
